import { useState } from "react";
import { Link } from "react-router-dom";

import { technologyIcon } from "../../../../Assessment/component/assessment/technologyIcon.js";

const DailyQuiz = () => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [correctAnswers, setCorrectAnswer] = useState(0);
  const [activeExplaination, setActiveExplaination] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [optionDisabled, setOptionDisabled] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);

  const quizData = [
    {
      id: 1,
      question: "Which language runs in a web browser?",
      technology: "JavaScript",
      options: ["Java", "C", "Python", "JavaScript"],
      correctAnswer: "JavaScript",
      explanation:
        "JavaScript is the only programming language that can run natively in web browsers without additional plugins.",
    },
    {
      id: 2,
      question: "What does CSS stand for?",
      technology: "CSS",
      options: [
        "Central Style Sheets",
        "Cascading Style Sheets",
        "Cascading Simple Sheets",
        "Cars SUVs Sailboats",
      ],
      correctAnswer: "Cascading Style Sheets",
      explanation:
        "CSS stands for Cascading Style Sheets, used to style and design HTML elements on a webpage.",
    },
    {
      id: 3,
      question: "What year was JavaScript launched?",
      technology: "JavaScript",
      options: ["1996", "1995", "1994", "None of the above"],
      correctAnswer: "1995",
      explanation:
        "JavaScript was introduced by Netscape in 1995 to make web pages interactive.",
    },
    {
      id: 4,
      question: "Which company developed React?",
      technology: "React",
      options: ["Google", "Facebook", "Microsoft", "Twitter"],
      correctAnswer: "Facebook",
      explanation:
        "React was developed by Facebook to build fast and dynamic user interfaces.",
    },
    {
      id: 5,
      question: "Inside which HTML element do we put JavaScript?",
      technology: "HTML",
      options: ["<javascript>", "<js>", "<script>", "<code>"],
      correctAnswer: "<script>",
      explanation:
        "JavaScript code is placed inside the <script> tag in HTML documents.",
    },
  ];

  const getOptionClass = (index) => {
    if (selectedOption === null) return "quiz-option";
    const correctIndex = quizData[currentQuestion]?.options.indexOf(
      quizData[currentQuestion]?.correctAnswer
    );
    if (index === correctIndex) return "option-bg-success"; // green
    if (index === selectedOption && selectedOption !== correctIndex)
      return "option-bg-danger"; // red
    return "quiz-option";
  };

  const handleOptions = (index) => {
    setSelectedOption(index);
    setOptionDisabled(true);
    if (
      quizData[currentQuestion]?.options[index] ===
      quizData[currentQuestion]?.correctAnswer
    ) {
      setCorrectAnswer((prev) => prev + 1);
    }
    setActiveExplaination(true);

    // setTimeout(() => {
    //   setActiveExplaination(false);
    //   setOptionDisabled(false);
    //   if (currentQuestion < quizData.length - 1) {
    //     setCurrentQuestion((prev) => prev + 1);
    //   } else {
    //     setShowResult(true);
    //   }
    //   setSelectedOption(null);
    // }, 2000);

    // Store timeout in a ref so we can clear/extend it
    let timer = setTimeout(() => {
      moveToNextQuestion();
    }, 2000);

    setTimeoutId(timer); // save timer id in state/ref
  };

  const moveToNextQuestion = () => {
    setActiveExplaination(false);
    setOptionDisabled(false);

    if (currentQuestion < quizData.length - 1) {
      setCurrentQuestion((prev) => prev + 1);
    } else {
      setShowResult(true);
    }

    setSelectedOption(null);
  };

  return (
    <div className="card card-custom animate-scale-in">
      <div className="card-body p-md-4">
        {showResult ? (
          <div className="">
            <div className="card-body text-center p-5">
              <div className="mb-4">
                {correctAnswers < 3 && (
                  <div className="text-muted-custom">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="64"
                      height="64"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-circle-x mb-3 text-muted-custom"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="m15 9-6 6"></path>
                      <path d="m9 9 6 6"></path>
                    </svg>
                    <h3 className="fw-bold text-muted-custom">
                      Keep Learning! 📚
                    </h3>
                  </div>
                )}
                {correctAnswers === quizData.length && (
                  <div class="text-accent">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="64"
                      height="64"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide lucide-circle-check-big mb-3"
                    >
                      <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                      <path d="m9 11 3 3L22 4"></path>
                    </svg>
                    <h3 class="fw-bold">Perfect Score! 🎉</h3>
                  </div>
                )}
                {correctAnswers >= 3 &&
                  correctAnswers < quizData.length && (
                    <div class="text-primary-custom">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="64"
                        height="64"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-brain mb-3"
                      >
                        <path d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z"></path>
                        <path d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z"></path>
                        <path d="M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4"></path>
                        <path d="M17.599 6.5a3 3 0 0 0 .399-1.375"></path>
                        <path d="M6.003 5.125A3 3 0 0 0 6.401 6.5"></path>
                        <path d="M3.477 10.896a4 4 0 0 1 .585-.396"></path>
                        <path d="M19.938 10.5a4 4 0 0 1 .585.396"></path>
                        <path d="M6 18a4 4 0 0 1-1.967-.516"></path>
                        <path d="M19.967 17.484A4 4 0 0 1 18 18"></path>
                      </svg>
                      <h3 class="fw-bold">Great Job! 👏</h3>
                    </div>
                  )}
              </div>

              <h4 className="mb-3 text-light">
                You scored {correctAnswers} out of {quizData.length}
              </h4>
              <div className="progress mb-4" style={{ height: "12px" }}>
                <div
                  className="progress-bar bg-gradient-primary"
                  style={{
                    width: `${(correctAnswers / quizData.length) * 100
                      }%`,
                  }}
                ></div>
              </div>
              <p className="text-muted-custom mb-4">
                Don't worry! Keep practicing and you'll improve your
                skills.
              </p>
              <button
                className="btn btn-gradient-primary me-3"
                onClick={() => {
                  setCurrentQuestion(0);
                  setCorrectAnswer(0);
                  setShowResult(false);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-rotate-ccw me-2"
                >
                  <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
                  <path d="M3 3v5h5"></path>
                </svg>
                Try Again
              </button>
              <button className="btn btn-outline-custom">
                <Link
                  to="/quiz"
                  className="text-decoration-none text-white"
                >
                  More Practice Problems{" "}
                </Link>
              </button>
            </div>
          </div>
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <span className="text-muted-custom px-2 text-nowrap">
                Question {currentQuestion + 1} of {quizData.length}
              </span>
              <div
                className="progress"
                style={{ width: "200px", height: "8px" }}
              >
                <div
                  className="progress-bar bg-gradient-primary"
                  style={{
                    width: `${((currentQuestion + 1) / quizData.length) * 100
                      }%`,
                  }}
                ></div>
              </div>
            </div>
            <div className="row mx-0">
              <div className="col-md-6 col-12 text-start fw-bold fs-4 text-light d-flex flex-md-column justify-content-between">
                <div>{quizData[currentQuestion]?.question}</div>
                <div className="py-2">
                  <img
                    src={technologyIcon.find((item) => item.technologyName.toLowerCase() === quizData[currentQuestion]?.technology.toLowerCase())?.technologyIconImageUrl || ""}
                    alt="..."
                    height={50}
                    width={50}
                  />
                </div>
              </div>
              <div className="col-md-6 col-12 mx-0 px-0">
                <div className="row mx-0 g-1">
                  {quizData[currentQuestion]?.options.map(
                    (Item, index) => (
                      <div
                        key={index}
                        onClick={() => handleOptions(index)}
                      >
                        <div className="col-12">
                          <button
                            className={` p-3 rounded cursor-pointer w-100 text-start border  ${optionDisabled
                              ? getOptionClass(index)
                              : "quiz-option"
                              }`}
                            disabled={optionDisabled}
                          >
                            <div className="d-flex align-items-center">
                              <div className="me-3 fw-bold">
                                {String.fromCharCode(65 + index)}.
                              </div>
                              <div>{Item}</div>
                            </div>
                          </button>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
            {activeExplaination && (
              <div
                className="explanation-box"
                onMouseEnter={() => {
                  clearTimeout(timeoutId); // cancel current timer
                  let newTimer = setTimeout(() => {
                    moveToNextQuestion();
                  }, 3000); // extend to 3 seconds
                  setTimeoutId(newTimer);
                }}
              >
                <div className="p-3 mt-4 rounded text-start border-custom explaination animate-scale-in">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-circle-check-big me-2 mb-1 text-accent"
                  >
                    <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                    <path d="m9 11 3 3L22 4"></path>
                  </svg>
                  <strong style={{ color: "#059669" }}>
                    Explanation:{" "}
                  </strong>{" "}
                  <br />
                  {quizData[currentQuestion]?.explanation}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default DailyQuiz;
